import { FileRepository } from '@src/main/shared/domain/file.repository';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

const path = '/files';

export const createFileHttpRepository = (tokenProvider: TokenProvider): FileRepository =>
  new FileHttpRepository(tokenProvider);

class FileHttpRepository implements FileRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');
    return token;
  }

  async download(keyFile: string, fileName: string): Promise<void> {
    const token = await this.getAuthToken();
    const blob = await api.fetchBlob(`${path}?keyFile=${keyFile}&fileName=${fileName}`, token);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
